<template>
  <b-modal
    :visible="value"
    @change="$emit('input', $event)"
    @hide="$emit('input', false)"
    title="Add Project"
    hide-footer
    size="lg"
    centered
  >
    <form @submit.prevent="submitProject()">
      <div class="form-group">
        <div class="row">
          <div class="col-12 mt-3">
            <label>Related Competency</label>
            <v-select
              multiple
              v-model="bodyAdd.relatedCompetency"
              :options="listCompetency"
              label="competency"
              :reduce="(e) => e.competency_id"
              placeholder="Select Related Competency"
              v-validate="'required'"
              name="Related Company"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Related Company')"
              >{{ errors.first("Related Company") }}</span
            >
          </div>
          <div class="col-6 mt-3">
            <p>Start Date</p>
            <v-date-picker
              style="width: 350px"
              v-model="bodyAdd.startDate"
              type="date"
              format="DD-MM-YYYY"
              :disabled-date="disablePastDates"
              placeholder="Select Date"
              v-validate="'required'"
              name="Start Date"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Start Date')"
              >{{ errors.first("Start Date") }}</span
            >
          </div>
          <div class="col-6 mt-3">
            <p>End Date</p>
            <v-date-picker
              style="width: 350px"
              v-model="bodyAdd.endDate"
              type="date"
              format="DD-MM-YYYY"
              :disabled-date="disablePastDates"
              placeholder="Select Date"
              v-validate="'required'"
              name="End Date"
            />
            <span class="text-sm text-danger" v-show="errors.has('End Date')">{{
              errors.first("End Date")
            }}</span>
          </div>
          <div class="col-12 mt-3">
            <label>Project Name</label>
            <input
              v-validate="'required'"
              name="Name"
              type="text"
              v-model="bodyAdd.projectName"
              class="form-control"
              placeholder="Project Name"
            />
            <span class="text-sm text-danger" v-show="errors.has('Name')">{{
              errors.first("Name")
            }}</span>
          </div>
          <div class="col-12 mt-3">
            <label>Project Description</label>
            <textarea
              type="text"
              v-model="bodyAdd.projectDescription"
              class="form-control"
              placeholder="Project Description"
              v-validate="'required'"
              name="Description"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Description')"
              >{{ errors.first("Description") }}</span
            >
          </div>

          <div class="col-12 mt-3">
            <label>Bussiness Need</label>
            <textarea
              type="text"
              v-model="bodyAdd.bussinessNeed"
              class="form-control"
              placeholder="Bussiness Need"
              v-validate="'required'"
              name="Bussiness Need"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Bussiness Need')"
              >{{ errors.first("Bussiness Need") }}</span
            >
          </div>
          <div class="col-12 mt-3">
            <label>Objectives</label>
            <textarea
              type="text"
              v-model="bodyAdd.objectives"
              class="form-control"
              placeholder="Objectives"
              v-validate="'required'"
              name="Objectives"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Objectives')"
              >{{ errors.first("Objectives") }}</span
            >
          </div>
          <div class="col-12 mt-3">
            <label>Goals</label>
            <textarea
              type="text"
              v-model="bodyAdd.goals"
              class="form-control"
              placeholder="Goals"
              v-validate="'required'"
              name="Goals"
            />
            <span class="text-sm text-danger" v-show="errors.has('Goals')">{{
              errors.first("Goals")
            }}</span>
          </div>
          <div class="col-12 mt-3">
            <label>Project Scope</label>
            <v-select
              :options="[
                'Accross BU',
                'Across Dept./Div. ( Within BU)',
                'Within Dept./Div.',
              ]"
              v-model="bodyAdd.scope"
              placeholder="Select Project Scope"
              v-validate="'required'"
              name="Project Scope"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Project Scope')"
              >{{ errors.first("Project Scope") }}</span
            >
          </div>
          <div class="col-12 mt-3">
            <label>Constraints</label>
            <textarea
              type="text"
              v-model="bodyAdd.constraints"
              class="form-control"
              placeholder="Constraints"
              v-validate="'required'"
              name="Constraints"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Constraints')"
              >{{ errors.first("Constraints") }}</span
            >
          </div>
          <div class="col-12 mt-3">
            <label>Deliverables</label>
            <textarea
              type="text"
              v-model="bodyAdd.deliverables"
              class="form-control"
              placeholder="Deliverables"
              v-validate="'required'"
              name="Deliverables"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Deliverables')"
              >{{ errors.first("Deliverables") }}</span
            >
          </div>
          <div class="row mt-5 mb-5">
            <div class="d-flex justify-content-between">
              <h3 class="mt-2">Project Team</h3>
              <b-button variant="primary" @click="addProjectTeams">
                <span class="fe fe-file-plus"></span>
                Add Project Teams
              </b-button>
            </div>
            <template v-for="(item, index) in bodyAdd.teams">
              <div class="col-5 mt-3">
                <label>Role</label>
                <v-select
                  :options="[
                    'Project Leader',
                    'Project Member/Co. Leader',
                    'Project Sponsor',
                  ]"
                  v-model="item.role"
                  placeholder="Select Role"
                  v-validate="'required'"
                  name="Role"
                />
                <span class="text-sm text-danger" v-show="errors.has('Role')">{{
                  errors.first("Role")
                }}</span>
              </div>
              <div class="col-5 mt-3">
                <label>Employee</label>
                <v-select
                  :options="listKaryawan"
                  label="employee_name"
                  :reduce="(e) => e.employee_nik"
                  v-model="item.nik"
                  placeholder="Select Employee"
                  v-validate="'required'"
                  name="Employee"
                />
                <span
                  class="text-sm text-danger"
                  v-show="errors.has('Employee')"
                  >{{ errors.first("Employee") }}</span
                >
              </div>
              <div class="col-2 mb-3" v-if="index != 0">
                <label></label>
                <b-button
                  variant="primary"
                  @click="delProjectTeams(index)"
                  class="mt-5"
                >
                  <span class="fe fe-trash"></span>
                </b-button>
              </div>
            </template>
          </div>
          <div class="col-12 mt-3">
            <label>Project Impact A</label>
            <v-select
              :options="['Tangible', 'Intangible']"
              v-model="bodyAdd.projectImpactA"
              placeholder="Select Project Impact A"
              v-validate="'required'"
              name="Project Impact A"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Project Impact A')"
              >{{ errors.first("Project Impact A") }}</span
            >
          </div>
          <div class="col-12 mt-3">
            <label>Impact</label>
            <textarea
              type="text"
              v-model="bodyAdd.impact"
              class="form-control"
              placeholder="Impact"
              v-validate="'required'"
              name="Impact"
            />
            <span class="text-sm text-danger" v-show="errors.has('Impact')">{{
              errors.first("Impact")
            }}</span>
          </div>
          <div class="col-12 mt-3">
            <label>Project Impact B</label>
            <v-select
              :options="[
                'Percentage (actual/target) > 100%',
                'Percentage (actual/target) = 100%',
                'Percentage (actual/target) < 100%',
              ]"
              v-model="bodyAdd.projectImpactB"
              placeholder="Select Project Impact B"
              v-validate="'required'"
              name="Project Impact B"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Project Impact B')"
              >{{ errors.first("Project Impact B") }}</span
            >
          </div>
          <div class="col-12 mt-3">
            <label>Attachment</label>
            <input
              type="file"
              @change="handleFileChange"
              class="form-control"
              accept=".jpg,.jpeg,.png"
              v-validate="'required'"
              name="Attachment"
            />
            <span
              class="text-sm text-danger"
              v-show="errors.has('Attachment')"
              >{{ errors.first("Attachment") }}</span
            >
          </div>
        </div>
      </div>
      <div class="form-group">
        <button
          style="margin-left: auto; float: right"
          class="mt-4 btn btn-primary"
          type="submit"
          v-if="isLoading == false"
        >
          Save
        </button>
        <button
          style="margin-left: auto; float: right"
          class="mt-4 btn btn-primary"
          type="button"
          disabled
          v-else
        >
          <span
            class="spinner-border spinner-border-sm"
            role="status"
            aria-hidden="true"
          ></span>
          Loading...
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { fetchAddNewProjectExperiential } from "../api";

export default {
  name: "AddActivitiesModal",
  props: {
    value: Boolean,
    showAddExperientialModal: {
      type: Boolean,
      default: false,
    },
    selectTeams: {
      type: Array,
      required: true,
    },
    voidCallback: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      isLoading: false,
      listKaryawan: [],
      listCompetency: [],
      bodyAdd: {
        relatedCompetency: "",
        projectName: "",
        projectDescription: "",
        bussinessNeed: "",
        objectives: "",
        goals: "",
        scope: "",
        constraints: "",
        deliverables: "",
        roles: [],
        startDate: "",
        endDate: "",
        percentage: null,
        assignee: [],
        teams: [
          {
            role: "",
            nik: localStorage.getItem("nik"),
          },
        ],
        fileAttach: null,
      },
      isSubmittingActivities: false,
    };
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("YYYY-MM-DD");
    },
    submitProject() {
      this.$validator.validateAll().then(async (res) => {
        if (!res) return false;
        this.isLoading = true;
        try {
          this.$swal({
            title: "Buat Proyek",
            text: "Apakah Anda yakin ingin membuat proyek ini?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#00D97E",
            cancelButtonColor: "#E63757",
            confirmButtonText: "Ya",
            cancelButtonText: "Batal",
          }).then(async (result) => {
            if (result.isConfirmed) {
              this.$swal({
                title: "Mengirim...",
                allowOutsideClick: false,
                didOpen: () => {
                  this.$swal.showLoading();
                },
              });
              let formData = new FormData();
              formData.append("name", this.bodyAdd.projectName);
              formData.append("description", this.bodyAdd.projectDescription);
              formData.append(
                "start_date",
                this.formatDate(this.bodyAdd.startDate)
              );
              formData.append(
                "end_date",
                this.formatDate(this.bodyAdd.endDate)
              );
              formData.append("involment", this.bodyAdd.projectInvolvement);
              formData.append("subordinate", this.bodyAdd.subordinate);
              formData.append("business_need", this.bodyAdd.bussinessNeed);
              formData.append("objectives", this.bodyAdd.objectives);
              formData.append("goals", this.bodyAdd.goals);
              formData.append("scope", this.bodyAdd.scope);
              formData.append("constraints", this.bodyAdd.constraints);
              formData.append("deliverables", this.bodyAdd.deliverables);
              formData.append("impact_a", this.bodyAdd.projectImpactA);
              formData.append("impact", this.bodyAdd.impact);
              formData.append("impact_b", this.bodyAdd.projectImpactB);
              formData.append(
                "competency",
                JSON.stringify(this.bodyAdd.relatedCompetency)
              );
              formData.append("teams", JSON.stringify(this.bodyAdd.teams));
              // Append files
              if (this.bodyAdd.fileAttach) {
                formData.append("files", this.bodyAdd.fileAttach);
              }
              await fetchAddNewProjectExperiential(formData)
                .then((response) => {
                  this.$swal.close();
                  this.$swal(
                    "Success",
                    "Proyek berhasil dibuat",
                    "success"
                  );
                  this.isAddProject = false;
                  this.isShowReport = false;
                  this.voidCallback && this.voidCallback();
                  this.bodyAdd.projectName = "";
                  this.bodyAdd.projectDescription = "";
                  this.bodyAdd.startDate = "";
                  this.bodyAdd.endDate = "";
                  this.bodyAdd.projectInvolvement = "";
                  this.bodyAdd.subordinate = "";
                  this.bodyAdd.bussinessNeed = "";
                  this.bodyAdd.objectives = "";
                  this.bodyAdd.goals = "";
                  this.bodyAdd.scope = "";
                  this.bodyAdd.constraints = "";
                  this.bodyAdd.deliverables = "";
                  this.bodyAdd.projectImpactA = "";
                  this.bodyAdd.impact = "";
                  this.bodyAdd.projectImpactB = "";
                  this.bodyAdd.projectImpact = "";
                  this.bodyAdd.teams = [
                    {
                      role: "",
                      nik: localStorage.getItem("nik"),
                    },
                  ];
                  this.selectedFile = null;
                  this.$validator.reset();
                  this.$emit("input", false);
                  this.$emit("refreshData"); // Emit event untuk refetch data di parent
                })
                .catch((error) => {
                  this.$swal.close();
                  this.$swal(
                    "Error",
                    "Proyek belum berhasil dibuat: " +
                      (error.response?.data?.error || error.message),
                    "error"
                  );
                })
                .finally(() => {
                  this.isLoading = false;
                });
            } else {
              this.isLoading = false;
            }
          });
        } catch (resp) {
          this.isLoading = false;
        }
      });
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      this.bodyAdd.fileAttach = file;
    },
    addProjectTeams() {
      let body = {
        role: "",
        nik: "",
      };
      this.bodyAdd.teams.push(body);
    },
    disablePastDates(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset time to the start of the day
      return date < today; // Disable dates before today
    },
    getEmployees() {
      this.$store.dispatch("employee/getEmployees").then((response) => {
        this.listKaryawan = response.data;
      });
    },
    getCompetency() {
      this.$store.dispatch("competency/getDataCompetencyByNik").then((res) => {
        this.listCompetency = res.data;
      });
    },
    delProjectTeams(index) {
      this.bodyAdd.teams.splice(index, 1);
    },
  },
  mounted() {
    this.getCompetency();
    this.getEmployees();
  },
};
</script>
